import { Tag } from 'antd';

type StatusConfigMap = {
  [key: string]: {
    label: string;
    colors: {
      border?: string;
      bg: string;
      text: string;
    };
    icon?: JSX.Element | null;
  };
};

export const StatusTag = ({
  status,
  statusConfigMap,
}: {
  status: keyof StatusConfigMap;
  statusConfigMap?: StatusConfigMap;
}) => {
  const config = statusConfigMap?.[status as keyof typeof statusConfigMap];
  return (
    <Tag
      icon={config?.icon}
      style={{
        border: 'none',
        backgroundColor: config?.colors?.bg,
        fontSize: 13,
        color: config?.colors?.text,
        padding: '5px 15px',
        borderRadius: 20,
        fontFamily: 'Poppins',
      }}
    >
      {config?.label ||
        status?.toString().charAt(0).toUpperCase() +
          status?.toString().slice(1).replaceAll('_', ' ')}
    </Tag>
  );
};
